<!-- One sheet, one table — the same shape as the impact packages below it, so
     the two read as two sections of one page rather than two screens. -->
<section class="site-wide" *ngIf="issues.length">
  <div class="card site-wide__sheet">
    <header class="card__header site-wide__head">
      <div class="site-wide__title">
        <h2 class="card__title site-wide__h">{{ heading }}</h2>
        <p class="site-wide__sub">{{ summary() }}</p>
      </div>
    </header>

    <table class="table table--dense site-wide__grid">
      <thead>
        <tr>
          <th class="site-wide__col-issue">Issue</th>
          <th class="site-wide__col-where">Where</th>
          <th class="table__num site-wide__col-pages">Pages</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table__row" *ngFor="let issue of issues; trackBy: trackByCode">
          <td class="site-wide__issue">
            <span class="site-wide__row">
              <span class="site-wide__name">{{ issue.title }}</span>
              <!-- Only the exception is labelled — see `isWarning`. -->
              <span class="site-wide__sev" *ngIf="isWarning(issue)">warning</span>
            </span>
            <!-- The whole point of the section: what the ONE fix is. Without it
                 this is a list of complaints with a bigger number attached. -->
            <span class="site-wide__fix" *ngIf="issue.fix">{{ issue.fix }}</span>
          </td>
          <td class="site-wide__where">{{ reach(issue) }}</td>
          <td class="table__num site-wide__pages" [attr.title]="samplesTitle(issue)">
            {{ issue.pageCount | number }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
